export default class UmbracoMediaApi {
  static apiBase = '/api/umbraco/media';

  static getImage(mediaId) {
    return fetch(this.apiBase + '/' + mediaId);
  }

  static searchMedia(searchObj) {
    return fetch(this.apiBase + '/search', {
      method: 'POST',      
      body: JSON.stringify(searchObj)
    });
  }
}